import instance, { apiUrl } from '@/services/axios.config';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Initial state - removed localStorage dependencies
const initialState = {
  token: null,
  role: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  user: null,
  subscription: null,
  loading: false,
  error: null
};

export const fetchUserSubscription = createAsyncThunk(
  'userSubscription/fetchSubscription',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ownerService.getuserSubscription();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
 


export const useReportAsync = createAsyncThunk(
  'userSubscription/useReport',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { userSubscription } = getState();
      const payload = userSubscription.subscription
      const response = await ownerService.updateSubscription(payload);

      return { updatedSubscription: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
// Async thunk for login
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async ({ email, password, fingerprint }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${apiUrl}/auth/login`, { email, password, fingerprint });

      return {
        token: data.token,
        role: data.role,
        user: data.user,
        user_id: data.user_id,
        subscription: data.subscription || null,
        subscription_status: data.subscription_status,
        is_subscription_active: data.is_subscription_active,
        is_subscription_expired: data.is_subscription_expired,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Async thunk for registration
export const registerUser = createAsyncThunk(
  'auth/registerUser',
  async ({ email, password, username, company_name, fingerprint,refcode }, { rejectWithValue }) => {
    try {

      const { data } = await axios.post(`${apiUrl}/auth/register`, {
        email,
        password,
        username,
        company_name,
        fingerprint,
        refcode
      });
      return {
        token: data.token,
        role: data.role,
        user: data.user,
        user_id: data.user_id,
        subscription: data.subscription || null,
        subscription_status: data.subscription_status,
        is_subscription_active: data.is_subscription_active,
        is_subscription_expired: data.is_subscription_expired,
      };

    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

 
// Auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Set token manually (useful for social login or external auth)
    setCredentials: (state, action) => {
      const { token, role, user, user_id, subscription, owner } = action.payload;
      state.token = token;
      state.role = role;
      state.user = user;
      state.subscription = subscription || null;
      state.owner = owner || null;
      state.isAuthenticated = !!token;
      state.error = null;

      // Store user_id in user object if needed
      if (user_id && state.user) {
        state.user.user_id = user_id;
      }
    },

    // Update user profile
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    setSubscription: (state, action) => {
      state.subscription = action.payload;
      state.error = null;
    },
 logoutUser: (state) => {
      state.token = null;
      state.role = null;
      state.isAuthenticated = false;
    },
    // Clear auth state (useful for complete logout)
    clearAuth: (state) => {
      state.token = null;
      state.role = null;
      state.user = null;
      state.subscription = null;
      state.owner = null;
      state.isAuthenticated = false;
      state.error = null;
      state.isLoading = false;
    },

    // Restore auth state (useful for app initialization with persisted state)
    restoreAuth: (state, action) => {
      const { token, role, user, subscription, owner } = action.payload;
      if (token) {
        state.token = token;
        state.role = role;
        state.user = user;
        state.subscription = subscription || null;
        state.owner = owner || null;
        state.isAuthenticated = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Login cases
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
         state.isLoading = false;
        state.isAuthenticated = true;
        state.token = action.payload.token;
        state.role = action.payload.role;
        state.user = action.payload.user;
        state.subscription = action.payload.subscription || null;
        state.owner = action.payload.owner || null;
        state.error = null;

        // Store user_id in user object if provided
        if (action.payload.user_id && state.user) {
          state.user.user_id = action.payload.user_id;
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.token = null;
        state.role = null;
        state.user = null;
        state.subscription = null;
        state.owner = null;
        state.error = action.payload;
      })

      // Fetch subscription cases
      .addCase(fetchUserSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.subscription = action.payload;
        state.error = null;
      })
      .addCase(fetchUserSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Register cases
      .addCase(registerUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {

        state.isLoading = false;
        state.isAuthenticated = true;
        state.token = action.payload.token;
        state.role = action.payload.role;
        state.user = action.payload.user;
        state.subscription = action.payload.subscription || null;
        state.owner = action.payload.owner || null;
        state.error = null;


        // Store user_id in user object if provided
        if (action.payload.user_id && state.user) {
          state.user.user_id = action.payload.user_id;
        }
      })
 
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = false;
        state.token = null;
        state.role = null;
        state.user = null;
        state.subscription = null;
        state.owner = null;
        state.error = action.payload;
      })

   
  },
});

// Export actions
export const { setSubscription,
  clearError,
  setCredentials,
  updateUser,
  clearAuth,
  restoreAuth,logoutUser
} = authSlice.actions;

// Selectors
export const selectAuth = (state) => state.auth;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUserRole = (state) => state.auth.role;
export const selectToken = (state) => state.auth.token;
export const selectCurrentUser = (state) => state.auth.user;
export const selectAuthLoading = (state) => state.auth.isLoading;
export const selectAuthError = (state) => state.auth.error;

// Enhanced selectors
export const selectSubscription = (state) => state.auth.subscription;
export const selectOwner = (state) => state.auth.owner;

// Helper function to check if subscription is expired
const isSubscriptionExpired = (subscription) => {
  if (!subscription?.end_date) return false;
  return new Date(subscription.end_date) < new Date();
};

export default authSlice.reducer;